import Router from 'App/routes/Router';
import MessageBox from 'sharedComponents/MessageBox';
import { useMultiScreenRegister, useMultiScreenSettings } from 'sharedComponents/MultiScreen';
import moment from 'moment';
import React, { Suspense } from 'react';
import { IntlProvider } from 'react-intl';
import useLocaleMessages from '../../../locales/locales';
import AppFallback from '../../components/Fallback/AppFallback';

import 'moment/locale/nb';

const App = ({ locale }) => {
  const [localeMessages, error] = useLocaleMessages(locale);
  useMultiScreenRegister();
  useMultiScreenSettings();

  if (!localeMessages && error) {
    return <MessageBox message="Something went wrong. Try again later or contact us for help." />;
  }
  if (!localeMessages) {
    return null;
  }

  moment.updateLocale('en', {
    week: {
      dow: 1,
    },
  });

  return (
    <IntlProvider locale={locale} key={locale} messages={localeMessages}>
      <Suspense fallback={<AppFallback />}>
        <Router />
      </Suspense>
    </IntlProvider>
  );
};

export default App;
